import src from "IMAGE";
export default { src, width: 3591, height: 2394, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/webp;base64,UklGRlYAAABXRUJQVlA4TEoAAAAvBwABAM1VICICHgg4CgAAAIDtWgAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD2HwAAEBH5VGTVuNPxdtCak5v7Q1ivAA=="};
